import usePermissionStore from "@/store/permissionStore";
import { watchEffect } from "vue";

export const permissionDirective = {
  mounted(el, binding) {
    const permissionStore = usePermissionStore();

    const checkPermission = () => {
      if (!permissionStore.hasPermission(binding.value)) {
        // 无权限：直接移除元素
        el.parentNode?.removeChild(el);
      }
    };
    checkPermission();

    el._permissionStop = watchEffect(() => {
      console.info(
        "permissionStore.state.permsList",
        permissionStore.state.permsList,
      );
      permissionStore.state.permsList; // 追踪响应式依赖
      checkPermission();
    });
  },
  unmounted(el) {
    if (el._permissionStop) {
      el._permissionStop();
      delete el._permissionStop;
    }
  },
};
